export const MDA_WAS_SIGNED_DAYS_PASSED = 15;
